// TODO: How should these be sorted?

// TODO: Add Althetic Skills, Office Skills (?)
export const categories = [
  {
    name: 'Data Science',
    color: '#515dd4',
  }, {
    name: 'Databases',
    color: '#3896e2',
  }, {
    name: 'Design',
    color: '#747fff',
  }, {
    name: 'Frameworks',
    color: '#64cb7b',
  }, {
    name: 'Javascript',
    color: '#d75858',
  }, {
    name: 'Languages',
    color: '#6968b3',
  }, {
    name: 'Machine Learning',
    color: '#e47272',
  }, {
    name: 'Python',
    color: '#37b1f5',
  }, {
    name: 'Tools',
    color: '#40494e',
  }, {
    name: 'Web Development',
    color: '#cc7b94',
  },
  {
    name: 'Java',
    color: '#c3423f',
  },
  {
    name: 'Cloud Computing',
    color: '#c37a00',
  },
];

export const skills = [
  {
    title: 'Javascript',
    compentency: 5,
    category: ['Web Development', 'Languages', 'Javascript'],
  },
  {
    title: 'PHP',
    compentency: 2,
    category: ['Web Development', 'Languages'],
  },
  {
    title: 'Node.JS',
    compentency: 5,
    category: ['Web Development', 'Javascript'],
  },
  {
    title: 'React / React-Native',
    compentency: 5,
    category: ['Web Development', 'Javascript'],
  },
  {
    title: 'Spring',
    compentency: 3,
    category: ['Frameworks', 'Java'],
  },
  {
    title: 'JUnit',
    compentency: 3,
    category: ['Java'],
  },{
    title: 'TDD',
    compentency: 3,
    category: ['Java'],
  },{
    title: 'Hibernate',
    compentency: 4,
    category: ['Java'],
  },{
    title: 'JPA',
    compentency: 4,
    category: ['Java'],
  },
  {
    title: 'Mockito',
    compentency: 3,
    category: ['Java'],
  },
  {
    title: 'Kotlin',
    compentency: 3,
    category: ['Java'],
  },
  {
    title: 'Bash',
    compentency: 3,
    category: ['Tools', 'Languages'],
  },
  {
    title: 'Jira',
    compentency: 3,
    category: ['Tools'],
  },
  {
    title: 'Java',
    compentency: 4,
    category: ['Languages'],
  },
  {
    title: 'Amazon Web Services',
    compentency: 3,
    category: ['Web Development', 'Tools', 'Cloud Computing'],
  },
  {
    title: 'Docker',
    compentency: 3,
    category: ['Tools', 'Cloud Computing'],
  }, {
    title: 'MongoDB',
    compentency: 4,
    category: ['Web Development', 'Databases'],
  },
  {
    title: 'PostgreSQL',
    compentency: 4,
    category: ['Web Development', 'Databases'],
  },
  {
    title: 'Firebase',
    compentency: 4,
    category: ['Web Development', 'Databases'],
  }, {
    title: 'Express.JS',
    compentency: 4,
    category: ['Web Development', 'Frameworks', 'Javascript'],
  }, {
    title: 'Flask',
    compentency: 5,
    category: ['Web Development', 'Frameworks', 'Python'],
  },
  {
    title: 'Data Analysis',
    compentency: 3,
    category: ['Data Science', 'Machine Learning'],
  },
  {
    title: 'Google Analytics',
    compentency: 3,
    category: ['Data Science', "Tools"],
  },
  {
    title: 'Selenium',
    compentency: 4,
    category: ['Tools', 'Java', "Frameworks"],
  },
  {
    title: 'Redux',
    compentency: 5,
    category: ['JavaScript', "Web Development"],
  },
  {
    title: 'Thunk',
    compentency: 5,
    category: ['JavaScript', "Web Development"],
  },
  {
    title: 'Git',
    compentency: 4,
    category: ['Tools'],
  },
  {
    title: 'Google Cloud Compute',
    compentency: 3,
    category: ['Tools', 'Cloud Computing'],
  },
  {
    title: 'Amazon Elastic Beanstalk',
    compentency: 4,
    category: ['Cloud Computing'],
  },
  {
    title: 'Amazon EC2',
    compentency: 4,
    category: ['Cloud Computing'],
  },
  {
    title: 'Google AutoML',
    compentency: 2,
    category: ['Cloud Computing'],
  },
  {
    title: 'Google BigQuery',
    compentency: 2,
    category: ['Cloud Computing'],
  },
  {
    title: 'Google MySQL',
    compentency: 2,
    category: ['Cloud Computing'],
  },
  {
    title: 'MySQL',
    compentency: 4,
    category: ['Databases'],
  },
  {
    title: 'DynamoDB',
    compentency: 2,
    category: [ 'Databases', 'Cloud Computing'],
  },
  {
    title: 'Google Cloud Storage',
    compentency: 2,
    category: ['Cloud Computing'],
  },
  {
    title: 'Google VM',
    compentency: 2,
    category: ['Cloud Computing'],
  },
  {
    title: 'Amazon Sagemaker',
    compentency: 3,
    category: ['Cloud Computing'],
  },
  {
    title: 'Amazon CloudWatch',
    compentency: 2,
    category: ['Cloud Computing'],
  },
  {
    title: 'Amazon S3',
    compentency: 4,
    category: ['Cloud Computing'],
  },
  {
    title: 'Numpy',
    compentency: 4,
    category: ['Data Science', 'Machine Learning', 'Python'],
  },
  {
    title: 'Tensorflow',
    compentency: 3,
    category: ['Data Science', 'Machine Learning', 'Python'],
  },
  {
    title: 'Jupyter',
    compentency: 4,
    category: ['Data Science', 'Machine Learning', 'Python'],
  },
  {
    title: 'Typescript',
    compentency: 5,
    category: ['Web Development', 'Languages'],
  },
  {
    title: 'HTML',
    compentency: 5,
    category: ['Web Development', 'Languages'],
  },
  {
    title: 'CSS',
    compentency: 4,
    category: ['Web Development', 'Languages'],
  },
  {
    title: 'Python',
    compentency: 5,
    category: ['Languages', 'Python'],

  },
  {
    title: 'Photoshop',
    compentency: 3,
    category: ['Design'],
  },
  {
    title: 'Premiere Pro',
    compentency: 2,
    category: ['Design'],
  },
  {
    title: 'After Effects',
    compentency: 2,
    category: ['Design'],
  },
  {
    title: 'Keras',
    compentency: 4,
    category: ['Machine Learning', 'Python'],
  },
  {
    title: 'GraphQL',
    compentency: 3,
    category: ['Tools'],
  },
  {
    title: 'Pandas',
    compentency: 5,
    category: ['Data Science', 'Python'],
  },
  {
    title: 'Matplotib',
    compentency: 3,
    category: ['Data Science', 'Python'],
  },
  {
    title: 'Scikit-Lean',
    compentency: 3,
    category: ['Data Science', 'Python'],
  },
];
